import {unref} from "vue";
import {AssertUtils,getNumberVal} from 'xmgoing-utils';

export default {
  initPaddingClass(borderConfig:any,extClassObj:any){
    //基础间距
    if(borderConfig.value.paddingTb==='small'){
      delete extClassObj["noPadding"];
      extClassObj["smallPadding"]=true;
    }
    //md间距
    if(borderConfig.value.paddingTb==='middle'){
      delete extClassObj["noPadding"];
      extClassObj["middlePadding"]=true;
    }
    //big间距
    if(borderConfig.value.paddingTb==='large'){
      delete extClassObj["noPadding"];
      extClassObj["largePadding"]=true;
    }

    //基础间距
    if(borderConfig.value.paddingLr==='small'){
      delete extClassObj["noPaddingLR"];
      extClassObj["smallPaddingLR"]=true;
    }
    //md间距
    if(borderConfig.value.paddingLr==='middle'){
      delete extClassObj["noPaddingLR"];
      extClassObj["middlePaddingLR"]=true;
    }
    //big间距
    if(borderConfig.value.paddingLr==='large'){
      delete extClassObj["noPaddingLR"];
      extClassObj["largePaddingLR"]=true;
    }
  },
  /**
   * 获取图表的高度
   * @param ctlHeight
   * @param sty
   * @param borderConfig
   */
  getCharWidthOrHeight(ctlHeight:number,borderConfig:any,appendNum:number):number{
    if(unref(borderConfig).paddingTb==='large'){
      ctlHeight=ctlHeight-22*2;
    }
    if(unref(borderConfig).paddingTb==='middle'){
      ctlHeight=ctlHeight-16*2;
    }
    //减去相应的间距
    if(unref(borderConfig).paddingTb==='small'){
      ctlHeight=ctlHeight-12*2;
    }

    //如果存在标题
    if(unref(borderConfig).ctlName==='borderHasTitle'){
      ctlHeight=ctlHeight - 58;
    }
    //内容切换标签
    if(unref(borderConfig).ctlName==='borderHasTab'){
      ctlHeight=ctlHeight - 55;
    }
    //查询tab标签
    if(unref(borderConfig).ctlName==='borderQueryTab'){
      ctlHeight=ctlHeight - 55;
    }
    ctlHeight=ctlHeight-2+appendNum;
    return ctlHeight;
  },
  /**
   * 获取像素高度
   * @param pxNumber
   */
  getPxNumber:(pxNumber)=>{
    //如果是数字
    if(!isNaN(parseFloat(pxNumber))){
      return pxNumber+"px";
    }
    //如果是百分比
    if((pxNumber+"").indexOf("%")>=0){
      return pxNumber;
    }
    return  pxNumber;
  }
}
